module.exports = __webpack_public_path__ + "static/media/INDOOR_ONLY.f14b3dca.svg";